import React from 'react';

const RegimeDetection = ({ regime }) => {
  if (!regime) return null;

  const { current, confidence, trending_pct, ranging_pct, volatile_pct, description, recommendation } = regime;

  const getRegimeColor = (regimeType) => {
    const colors = {
      'TRENDING': '#10b981',
      'RANGING': '#3b82f6',
      'VOLATILE': '#ef4444',
      'MIXED': '#f59e0b'
    };
    return colors[regimeType] || '#6b7280';
  };

  const color = getRegimeColor(current);

  return (
    <div style={{
      background: 'rgba(255,255,255,0.96)',
      borderRadius: 12,
      padding: 20,
      border: '1px solid rgba(0,0,0,0.08)'
    }}>
      <h4 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 700, color: '#1f2937' }}>
         Market Regime Detection
      </h4>

      {/* Current Regime Badge */}
      <div style={{
        display: 'inline-block',
        padding: '8px 16px',
        background: `${color}20`,
        color,
        borderRadius: 8,
        fontSize: 18,
        fontWeight: 800,
        marginBottom: 16
      }}>
        {current}
      </div>

      {/* Confidence */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
          Confidence: {confidence?.toFixed(1)}%
        </div>
        <div style={{
          height: 8,
          background: '#f3f4f6',
          borderRadius: 4,
          overflow: 'hidden'
        }}>
          <div style={{
            height: '100%',
            width: `${confidence}%`,
            background: color,
            borderRadius: 4
          }} />
        </div>
      </div>

      {/* Breakdown */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#1f2937', marginBottom: 8 }}>
          Regime Breakdown:
        </div>
        
        {/* Trending */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
            <span style={{ color: '#6b7280' }}>Trending</span>
            <span style={{ fontWeight: 600, color: '#10b981' }}>{trending_pct?.toFixed(1)}%</span>
          </div>
          <div style={{ height: 6, background: '#f3f4f6', borderRadius: 3, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${trending_pct}%`, background: '#10b981', borderRadius: 3 }} />
          </div>
        </div>

        {/* Ranging */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
            <span style={{ color: '#6b7280' }}>Ranging</span>
            <span style={{ fontWeight: 600, color: '#3b82f6' }}>{ranging_pct?.toFixed(1)}%</span>
          </div>
          <div style={{ height: 6, background: '#f3f4f6', borderRadius: 3, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${ranging_pct}%`, background: '#3b82f6', borderRadius: 3 }} />
          </div>
        </div>

        {/* Volatile */}
        <div style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
            <span style={{ color: '#6b7280' }}>Volatile</span>
            <span style={{ fontWeight: 600, color: '#ef4444' }}>{volatile_pct?.toFixed(1)}%</span>
          </div>
          <div style={{ height: 6, background: '#f3f4f6', borderRadius: 3, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${volatile_pct}%`, background: '#ef4444', borderRadius: 3 }} />
          </div>
        </div>
      </div>

      {/* Description */}
      <div style={{
        padding: 12,
        background: '#f9fafb',
        borderRadius: 8,
        marginBottom: 12
      }}>
        <div style={{ fontSize: 12, color: '#4b5563', marginBottom: 4 }}>
          <strong>Analysis:</strong> {description}
        </div>
      </div>

      {/* Recommendation */}
      <div style={{
        padding: 12,
        background: `${color}10`,
        border: `1px solid ${color}30`,
        borderRadius: 8
      }}>
        <div style={{ fontSize: 12, color: '#1f2937' }}>
          <strong style={{ color }}>Recommendation:</strong> {recommendation}
        </div>
      </div>
    </div>
  );
};

export default RegimeDetection;
